<template>
    <div class="br-container">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Bordeaux de reversement</div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">
                    Informations sur vos bordereaux :
                </div>
            </div>
            <div class="col-12">
                <CommissionsCustomFilter
                    :filters="filters"
                    @filter="handleFilter"
                />
                <template v-if="isBusy">
                    <Preloader />
                </template>
                <template v-else>
                    <template v-if="reversals.data.length > 0">
                        <div class="clients__table mb-3">
                            <div class="clients__table__item">
                                <div class="clients__table__item--cell">Date</div>
                                <div class="clients__table__item--cell small_wider">N° de Bordereau</div>
                                <div class="clients__table__item--cell">Montant</div>
                                <div class="clients__table__item--cell icon-cell">Bordereau</div>
                            </div>

                            <div class="clients__table__item" v-for='reversal in reversals.data'>
                                <div class="clients__table__item--cell">{{parseDate(reversal.mutuaide_reversal_date)}}</div>
                                <div class="clients__table__item--cell small_wider">{{reversal.mutuaide_reversal_number}}</div>
                                <div class="clients__table__item--cell">{{parseFloat(reversal.amount).toFixed(2)}} €</div>
                                <div class="clients__table__item--cell icon-cell">
                                <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_pdf(reversal.id)"/>
                                </div>
                            </div>
                        </div>
                        <pagination :data="reversals" @pagination-change-page="getReversals" />
                    </template>
                    <template v-else>
                        <div class="subscribes-empty">Il n'y a aucun bordereau de reversement à ce jour.</div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Preloader from '@/components/Preloader';
import CommissionsCustomFilter from '@/components/Commissions/CommissionsCustomFilter';

export default {
    name: "BordeauxReversement",
    components: {
        Preloader,
        CommissionsCustomFilter
    },
    data() {
        return {
            representative_id: null,
            isBusy: false,
            reversals: {
                data: []
            },
            filters: {
                start_date: null,
                end_date: null,
                amount: ''
            },
        }
    },
    methods: {
        handleFilter(filters) {
            this.filters = { ...filters };
            this.getReversals();
        },
        getReversals(page = 1) {
            this.isBusy = true;
            if (this.representative_id) {
                let params = this.parseFilter(page);
                this.apiGet(`mutuaide-reversals/${this.representative_id}`, params)
                .then(response => {
                    if (response && response.data && response.data.status === 'success') {
                        this.reversals = response.data.results;
                        this.isBusy = false;
                        console.log(this.reversals);
                    }
                })
                .catch(error => this.showErrorNotification(error));
            }
        },
        parseDate(date) {
            return this.moment(date).format('DD/MM/YYYY');
        },
        parseFilter(page = 1) {
            let data = {}
            if (this.filters.start_date) {
                data.start_date = this.filters.start_date;
                data.start_date.setHours(0, 0, 0, 0);
            }
            if (this.filters.end_date) {
                data.end_date = this.filters.end_date;
                data.end_date.setHours(23, 59, 59, 0);
            }
            if (this.filters.amount) data.amount = this.filters.amount;

            data.page = page;

            return data;
        },
        show_pdf(id) {
            this.refreshTokenForce()
                .then(() => window.location = this.getApiAuthUrl(`mutuaide-reversals/pdf/${id}`))
                .catch(error => this.showErrorNotification(error));
        },
    },
    mounted() {
        this.representative_id = this.$store.getters.getRepresentative.id;
        this.getReversals();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Representative/BordeauxReversement.vue